import { c as _c } from "react/compiler-runtime";
import { KeyValueGrid } from "@/components/domain/key-value-grid";
import { KeyValueSkeleton } from "@/components/domain/key-value-skeleton";
import { ReportSection } from "@/components/domain/report-section";
import { sections } from "@/lib/constants/sections";
import { Skeleton } from "@domainstack/ui/skeleton";
export function CertificatesSectionSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative overflow-hidden rounded-xl border bg-background/60 p-3 backdrop-blur-lg"><KeyValueGrid colsDesktop={2}><KeyValueSkeleton label="Issuer" widthClass="w-[100px]" withLeading={true} /><KeyValueSkeleton label="Subject" widthClass="w-[100px]" /><KeyValueSkeleton label="Valid from" widthClass="w-[120px]" withSuffix={true} /><KeyValueSkeleton label="Valid to" widthClass="w-[120px]" withSuffix={true} /></KeyValueGrid></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ReportSection isLoading={true} {...sections.certificates}>{t0}<div className="mt-4 flex justify-center"><Skeleton className="h-8 w-28 rounded-md" /></div></ReportSection>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}